import { render, staticRenderFns } from "./partnerStatusChangeDialog.vue?vue&type=template&id=f73a3d64&scoped=true"
import script from "./partnerStatusChangeDialog.vue?vue&type=script&lang=ts"
export * from "./partnerStatusChangeDialog.vue?vue&type=script&lang=ts"
import style0 from "./partnerStatusChangeDialog.vue?vue&type=style&index=0&id=f73a3d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73a3d64",
  null
  
)

export default component.exports